export default "__VITE_ASSET__DkBcUSq8__"